import { useTranslation } from 'react-i18next';
import KpiCard from './KpiCard';
import { useDashboardKpis } from './useDashboardKpis';

function CarIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 17h14l-2-7H7l-2 7zM5 17v3M19 17v3" />
      <circle cx="9" cy="13" r="1" />
      <circle cx="15" cy="13" r="1" />
    </svg>
  );
}

export default function ActiveVehiclesWidget() {
  const { t } = useTranslation();
  const { data, loading } = useDashboardKpis();

  const active = data?.active_vehicles ?? 0;
  const total  = data?.total_vehicles ?? 0;
  const inService = data?.vehicles_in_service ?? 0;

  const caption = inService > 0
    ? t('dashboard.kpi_vehicles_in_service', { count: inService, defaultValue: `${inService} til service` })
    : t('dashboard.kpi_vehicles_all_active', { defaultValue: 'Alle aktive' });

  return (
    <KpiCard
      label={t('dashboard.kpi_active_vehicles', { defaultValue: 'Aktive biler' })}
      value={active}
      unit={total > 0 ? `/ ${total}` : undefined}
      icon={<CarIcon />}
      iconTone="ink"
      delta={inService > 0
        ? { label: '●', direction: 'neutral' }
        : undefined}
      caption={caption}
      loading={loading}
    />
  );
}
